export const aciArrowRight = {
    iconName: 'arrow-right',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M7.17 2.04a.641.641 0 00-.275.284.618.618 0 00.011.421c.034.075 1.014 1.067 4.606 4.66 2.51 2.51 4.563 4.578 4.563 4.595 0 .017-2.054 2.085-4.563 4.595-3.592 3.593-4.572 4.585-4.606 4.66a.618.618 0 00-.01.42c.043.105.169.235.275.284a.56.56 0 00.448-.012c.082-.041 1.094-1.043 4.713-4.665 4.246-4.25 4.613-4.623 4.675-4.75.074-.151.13-.381.13-.532 0-.15-.056-.381-.13-.532-.062-.127-.43-.5-4.675-4.75-3.619-3.622-4.63-4.624-4.713-4.665a.56.56 0 00-.448-.012z',
                fill: 'currentColor',
            },
        },
    },
};
